import { useState, useEffect } from "react";
import { TermsModalProps } from "./TermsModal";
import { LegalTextsLinks } from "../../constants/AppLinks";
import ReactMarkdown from "react-markdown";
import "./termsMDStyles.css";
import styled from "styled-components";
import { CircularProgress } from "@mui/material";
const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 130px;
  width: 300px;
  gap: 20px;
  color: #fbb23ec1;
  font-size: 24px;
  font-weight: lighter;
  text-align: center;
`;

const termsLoaderHOC = (Component: React.ComponentType<TermsModalProps>) => {
  return (props: {
    open: boolean;
    onClose: () => void;
    isTerms: boolean;
    isPrivacy: boolean;
  }) => {
    const { open, onClose, isTerms, isPrivacy } = props;
    const termsUrl = LegalTextsLinks.termsAndConditions;
    const privacyUrl = LegalTextsLinks.privacyPolicy;

    const [terms, setTerms] = useState<string | null>(() => {
      return sessionStorage.getItem("terms");
    });
    const [privacy, setPrivacy] = useState<string | null>(() => {
      return sessionStorage.getItem("privacy");
    });

    useEffect(() => {
      if (!terms) {
        fetch(termsUrl)
          .then((response) => response.text())
          .then((data) => {
            setTerms(data);
            sessionStorage.setItem("terms", data);
          })
          .catch((error) => {
            console.error("Error fetching terms:", error);
          });
      }

      if (!privacy) {
        fetch(privacyUrl)
          .then((response) => response.text())
          .then((data) => {
            setPrivacy(data);
            sessionStorage.setItem("privacy", data);
          })
          .catch((error) => {
            console.error("Error fetching privacy policy:", error);
          });
      }
    }, [terms, privacy, termsUrl, privacyUrl]);

    const isLoading = terms === null || privacy === null;

    const displayedData = isLoading ? (
      <LoadingContainer>
        <CircularProgress
          sx={{
            color: "#fbb23ed8",
          }}
        />
        {`Loading${isTerms ? " Terms and Conditions" : " Privacy Policy"}...`}
      </LoadingContainer>
    ) : isTerms ? (
      <ReactMarkdown className="markdown-body-terms">{terms}</ReactMarkdown>
    ) : isPrivacy ? (
      <ReactMarkdown className="markdown-body-terms">{privacy}</ReactMarkdown>
    ) : null;

    if (displayedData) {
      return (
        <Component
          open={open}
          onClose={onClose}
          displayedData={displayedData}
        />
      );
    } else {
      return <></>;
    }
  };
};

export default termsLoaderHOC;
